if (document.getElementById('question-modal')) {
    require('./question-modal/question-modal.less');
    import('./question-modal/question-modal').then(function (module) {
        module.default;
    });
}

if (document.getElementById('address-map')) {
    window.$ = window.jQuery = require('jquery');
    require('./../libs/fancybox/js/fancybox');
    $('.fancy-gall').fancybox({});

    import('./maps/maps').then(function (module) {
        module.default;
    });
}

if (document.getElementById('old-cart')) {
    import('./old-cart/old-cart').then(function (module) {
        module.default;
    });
}

if (document.getElementById('upload-file')) {
    import('./uploadFile/uploadFile').then(function (module) {
        module.default;
    });
}

if (document.getElementById('sendResult')) {
    import('./sendMessage/sendMessage').then(function (module) {
        module.default;
    });
}

if (document.getElementById('image-editor')) {
    import('./image-editor/image-editor').then(function (module) {
        module.default;
    });
}

if (document.getElementById('geo-select')) {
    import('./geo/geo').then(function (module) {
        module.default;
    });
}

if (document.getElementById('description-editor')) {
    import('./description-editor/description-editor').then(function (module) {
        module.default;
    });
}

if (document.getElementById('fastreviews-moderation')) {
    import('./fastreviews-moderation/fastreviews-moderation').then(function (
        module
    ) {
        module.default;
    });
}

if (document.getElementById('messengers-urls')) {
    import('./messengers-urls/messengers-urls').then(function (module) {
        module.default;
    });
}
